import { axiosClient } from 'src/services/axiosInstance'

import type { FreeShippingProgressResponse } from '../types/freeShippingProgress'

export const getFreeShippingProgress = async (
  orderFormId: string
): Promise<FreeShippingProgressResponse> => {
  const { data } = await axiosClient.get<FreeShippingProgressResponse>(
    `/api/checkout/orderForm/${orderFormId}/free-shipping-progress`
  )

  return data
}
